import { Api } from 'lib/api.mjs';

/** Bounties — one-off targets that pay on top of the weekly structure. */

export function getBounties({ signal } = {}) {
  return Api.get('/bounties', { signal });
}

/** @param {Object} payload */
export function createBounty(payload) {
  return Api.post('/bounties', { body: payload });
}

/** @param {{ id: string }} payload */
export function deleteBounty({ id }) {
  return Api.delete(`/bounties/${id}`);
}

/** @param {{ id: string }} payload Mark a bounty as hit. */
export function hitBounty({ id }) {
  return Api.post(`/bounties/${id}/hit`, {});
}
